import { createFileRoute } from "@tanstack/react-router";

import { AppShell } from "@/components/app/app-shell";
import { SequenceCommandCenter } from "@/components/app/sequence-command-center";

const description =
  "Every outreach sequence enrollment across the team, with funnel numbers, step performance, and deliverability.";

export const Route = createFileRoute("/_authenticated/t1dwpanel/sequences")({
  head: () => ({
    meta: [
      { title: "Sequence command center | Warrior Volunteer" },
      { name: "description", content: description },
      { property: "og:title", content: "Sequence command center | Warrior Volunteer" },
      { property: "og:description", content: description },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: AdminSequencesPage,
});

function AdminSequencesPage() {
  return (
    <AppShell title="Sequences" eyebrow="Admin">
      <SequenceCommandCenter mode="admin" />
    </AppShell>
  );
}
